import { Translation } from 'common/actions';
import { Image } from 'common/components/image';
import { Epg } from 'common/constants/data-types';
import { isEmpty } from 'lodash';
import React, { useMemo } from 'react';
import { connect } from 'react-redux';

interface StoreState {
  i18n: Translation;
}

interface VodOverlayProps {
  asset: Epg;
  // Redux injected
  i18n: Translation;
}

const VodOverlay = ({ asset, i18n }: VodOverlayProps) => {
  const bannerUrl = useMemo(
    () => asset.photos.find((e) => e.type === 'cover')?.url,
    [asset.photos]
  );

  if (isEmpty(i18n)) return null;

  return (
    <div className="player-overlay-container">
      <Image className="banner" src={bannerUrl} />
    </div>
  );
};

const mapStateToProps = ({ i18n }: StoreState) => ({
  i18n
});

export default React.memo(connect(mapStateToProps, {})(VodOverlay));
